import 'slick-carousel'
import 'jquery-scrollify'
import GET_ARTICLES from '../plugins/getArticles';

export default function HOME() {
  const w = window
  w.jQuery = $
  

  $(() => {
  
    // トップページカスタム
    $.topInit();
  
    // ブロック整形
    (function(__){ $.each(__, $.topBlockCustomizer) }({
      'information':{
        button:{
          disp: true,
          text: 'VIEW ALL',
          attr:{
            class: 'button button-border button-medium'
          }
        },
        title:{
          html: '<span>NEWS & TOPICS</span><small>新着情報</small>' // プレーンテキストで動的にする場合は false
        },
        category:{
          disp: true,
          opt:{
            content: 'information',
            blockClass: 'p-informationBlock__catlist',
            addAll: true,
            linkClass:'button button-border button-xsmall'
          }
        },
        itemlayout: function($this,$catetitle,$date,$new,$title,$catch,$body){
          $this
            .append( $title )
            .append( $catetitle )
            .append( $date.append($new) )
            .append( $catch )
            .append( $body );
          // $date.insertAfter( $catetitle );
        },
        cb: obj => obj.find('.artloop').each( (i,obj) => {
          $(obj).unwrap().wrapInner('<div class="artloop__body"/>')
          $('.thum_img',obj).prependTo(obj)
          $('.artloop__body > table',obj).prependTo(obj)
          $('table',obj).remove()
        })
      }
    }));
  
  })
  
  $(()=>{

    $.when(
      w.load['top-intro'],
      w.load['top-lesson'],
      w.load['top-swing']
    ).done(()=>{
      let w = $(window).width()
      if( w >= 768 ){
        $.scrollify({
          section:"[data-scroll-section]",
          setHeights: false,
          overflowScroll:true,
          updateHash: false,
          standardScrollElements: '.p-informationBlock, .p-top-brand, .p-top-uservice, .p-contfooter footer',
          afterResize(){
            w = $(window).width()
            $.scrollify.update()
            if ( w >= 768 ){
              $.scrollify.enable()
            } 
            else $.scrollify.disable()
          }
        })
      }
    })

    $.when(
      w.load['top-intro'],
      $.getScript('/asset/js/vendor/jquery.mb.YTPlayer.min.js')
    ).done(()=>{

      GET_ARTICLES('.p-top-intro [data-plugin="getArticles"]').done(() => {
        $('.p-top-intro__pickup-list').slick({
          autoplay: true,
          fade: false,
          speed: 200,
          pauseOnHover: false,
          pauseOnFocus: false,
          centerMode: true,
          arrows: false,
          infinite: true,
          variableWidth: true,
          swipeToSlide:true,
          slidesToShow: 4,
          responsive: [{
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            }
          }, {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              infinite: true,
              centerMode: true
            }
          }]
        })
      })
  
      /****************************
       * movie background
       */
      const $MV = $('[data-plugin="ytplayer"]')
      const param = id => `{
        videoURL: '${id}',
        containment: 'body',
        mute: true,
        showControls: false,
        autoPlay: true,
        useOnMobile: true,
        showYTLogo: false,
        abundance: 0,
        stopMovieOnBlur: false,
        loop: true,
        startAt: 0,
        anchor: 'center,center',
        quality: '${($.UA.is_mobile)? 'default': 'hd1080'}'
      }`.replace(/\n|\s/g,'')
      $MV.attr('data-property',param('ZiMLeSoU6UY'))
      $MV.YTPlayer()
      $MV.YTPPlay()
  
    })

    $.when(
      w.load['top-uservoice']
    ).done(()=>{
      GET_ARTICLES('.p-top-uservoice [data-plugin="getArticles"]').done(() => {
        $('.p-top-uservoice__list').slick({
          autoplay: true,
          fade: false,
          speed: 200,
          pauseOnHover: false,
          pauseOnFocus: false,
          centerMode: true,
          arrows: false,
          infinite: true,
          variableWidth: true,
          swipeToSlide:true,
          slidesToShow: 4,
          responsive: [{
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            }
          }, {
            breakpoint: 768,
            settings: "unslick"
          }]
        })
      })
    })
  })
  
}